<template>
    <v-card flat style="border-top: 1px solid lightgray">
        <v-overlay :value="loadingTagList">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-data-table
            :items-per-page="50"
            :footer-props="footerProps"
            :search="searchTagString"
            class="tags-table"
            dense
            :headers="tableHeaders"
            :items="tags"
            item-key="id"
        >
            <template v-slot:item="{ item }">
                <tr
                    :key="'tag_' + item.id"
                    @click="handleTableRowClick(item)"
                    :class="{ activeTableRow: activeTag && parseInt(item.id) === parseInt(activeTag.id) }"
                >
                    <td>{{ item.id }}</td>
                    <td>{{ item.name ? item.name : "-" }}</td>
                    <td>{{ item.description ? item.description : "-" }}</td>
                    <td style="text-align: right;">{{ item.clients_count }}</td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "tag-list",
    data() {
        return {
            footerProps: { "items-per-page-options": [25, 50, 100] },
            tableHeaders: [
                {
                    text: this.t("ID"),
                    align: "left",
                    value: "id",
                    width: "80px"
                },
                {
                    text: this.t("Name"),
                    align: "left",
                    value: "name"
                },
                {
                    text: this.t("Description"),
                    align: "left",
                    value: "description"
                },
                {
                    text: this.t("Clients"),
                    align: "right",
                    value: "clients_count",
                    width: "100px"
                }
            ]
        };
    },
    async mounted() {
        await this.getTagList();
    },
    computed: {
        ...mapState("TagStore", ["tags", "loadingTagList", "activeTag", "searchTagString"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    methods: {
        ...mapActions("TagStore", ["getTagData", "getTagList"]),
        handleTableRowClick(tag) {
            if (!this.hasPermissionForAction(PermissionsConstants.TAG, PermissionsConstants.VIEW)) {
                return;
            }
            if (this.$route.name !== "tag-view") {
                this.$router.push({ name: "tag-view", params: { tagId: tag.id } });
                return;
            }
            if (this.$route.name === "tag-view" && parseInt(tag.id) !== parseInt(this.$route.params.tagId)) {
                this.$router.push({ name: "tag-view", params: { tagId: tag.id } });
                this.getTagData(tag.id);
            }
        }
    }
};
</script>

<style scoped>
.activeTableRow {
    background-color: #f41823;
    color: #fff;
}

.activeTableRow:hover {
    background-color: #e11520 !important;
    color: #fff !important;
}

.v-data-table-header {
    background-color: #f0f0f0;
}
::v-deep .v-data-table-header th {
    white-space: nowrap;
}
td {
    height: 25px !important;
}
</style>
